module.exports = __webpack_public_path__ + "img/CIMG6685.e26ff656.jpg";